import { JSX } from "react";
import { useAppSelector } from "../../../app/hooks";
import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useCategoryProducts } from "../hooks/useCategoryProducts";
import { CategoryProductList } from "./CategoryProductList";
import { SimpleProduct } from "../../../common/utils/productConverters";

interface CategoryProductListContainerProps {
    categoryId: number;
    isExpanded: boolean;
    onProductSelect: (product: SimpleProduct) => void;
    onProductClick: (product: SimpleProduct) => void;
}

export const CategoryProductListContainer = (
    props: CategoryProductListContainerProps,
): JSX.Element | null => {
    const { categoryId, isExpanded, onProductSelect, onProductClick } = props;
    const { products, isLoading } = useCategoryProducts({ categoryId });

    const userData = useGetUserInfoQuery();
    const { activeLanguage } = userData?.data || { activeLanguage: null };

    const { gridLayout, disableCheckbox, selectedProducts } = useAppSelector(
        (state) => state.productRange,
    );

    if (!isExpanded) {
        return null;
    }

    return (
        <CategoryProductList
            products={products}
            gridLayout={gridLayout}
            isLoading={isLoading}
            disableCheckbox={disableCheckbox}
            selectedProducts={selectedProducts}
            activeLanguage={activeLanguage}
            onProductSelect={onProductSelect}
            onProductClick={onProductClick}
        />
    );
};
